//**auto-generated don't edit this code**//
export enum PrintOut {
	None,
	IncorrectOnly,
	IncorrectUntested,
	FullSet,
}